/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Card } from 'ui-component-library';
import { object } from 'prop-types';

import Activity from '../../common/activities/activity';
import InfoTooltipButton from '../../common/info-tooltip-button/info-tooltip-button';
import { TOOLTIP_MESSAGES } from '../../../../constants';

/**
 * Last Human Update Card Component
 * @param {object} params - Object containing props
 * @param {object} params.lastUpdate - Object containing lastHumanUpdate information
 * @return {element}
 */
const LastHumanUpdate = ({ lastUpdate }) => (
  <Card
    title="Last Human Update"
    headerContent={<InfoTooltipButton text={TOOLTIP_MESSAGES['last-human-update']} isPrimary />}
    isPaddingRemoved={!!lastUpdate}
  >
    <Activity activity={lastUpdate} hideComments />
  </Card>
);

LastHumanUpdate.propTypes = {
  lastUpdate: object,
};

LastHumanUpdate.defaultProps = {
  lastUpdate: null,
};

export default LastHumanUpdate;
